import React from 'react';
import { Link } from 'react-router-dom';

const TokenAdminList = props => {
    if (!props.data) {
        return (
            <div className='broad'>Loading...</div>
        )
    }

    if (props.data.length === 0) {
        return (
            <div className='empty'>
                No data found...
            </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                        <th>User Key</th>
                        <th>Registration</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Token Symbol</th>
                        <th>Token Status</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.data.map((item) => {
                            return (
                                <tr key={item.key}>
                                    <td className="keyfield"><Link to={`/users/${item.key}`}>{item.key}</Link></td>
                                    <td>{item.created}</td>
                                    <td>{item.firstname + ' ' + item.lastname}</td>
                                    <td>{item.email}</td>
                                    <td>{item.token && item.token.symbol
                                        ? <Link to={`/tokens/${item.token.symbol.toLowerCase()}`}>
                                            <span>{item.token.symbol}</span>
                                        </Link> : ''
                                    }
                                    </td>
                                    <td>{item.token && item.token.generated_status}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default TokenAdminList;



// WEBPACK FOOTER //
// ./src/components/widgets/TokenAdminList.js